<template>
  <div class="legend-plot">
    <app-analyze-legend-user
      v-bind:users="usersModified"
      v-bind:visible="visible.user"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import AppAnalyzeLegendUser from './AppAnalyzeLegendUser.vue'

export default {
  name: 'AppAnalyzeLegendPlot',
  components: {
    AppAnalyzeLegendUser,
  },
  props: {
    /**
     * ユーザー
     */
    users: {
      type: Array,
      default: () => [],
    },
    /**
     * 表示状態
     */
    visible: {
      type: Object,
      default: () => ({ user: true }),
    },
  },
  computed: {
    /**
     * 加工したユーザー
     * - hex変換した色追加
     * - visibleの割当
     * @type {Array.<Object>}
     */
    usersModified: function () {
      return this.users.map((u) => ({
        ...u,
      }))
    },
  },
}
</script>
